import {apiSlice} from './apiSlice';

/**
 * Danh mục địa giới hành chính VN (tỉnh → phường) từ backend Location2.
 * Cache lâu (dữ liệu ít đổi). Dùng cho select địa chỉ ở form tài khoản.
 */
export const locationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getProvinces: builder.query({
			query: () => ({url: 'location/provinces', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			keepUnusedDataFor: 86400,
		}),
		getWards: builder.query({
			query: (provinceId) => ({url: `location/wards?province_id=${provinceId}`, method: 'get'}),
			transformResponse: (body) => body?.data || [],
			keepUnusedDataFor: 86400,
		}),
	}),
});

export const {
	useGetProvincesQuery,
	useGetWardsQuery,
} = locationApiSlice;
